"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorHandling = void 0;
const errors_1 = require("../../consts/errors");
class ErrorHandling {
    static generateErrorResult(message) {
        return { color: null, error: { message } };
    }
    static generateInputErrorMessage(colorType, colorString, format) {
        const errorPrefix = `Input ${colorType} color string could not be parsed.`;
        const actualStringReceived = `String received: ${colorString}.`;
        const messageStrings = [errorPrefix, actualStringReceived];
        if (format) {
            const expectedFormat = `Expected format: ${format}.`;
            messageStrings.splice(1, 0, expectedFormat);
        }
        return messageStrings.join(' ');
    }
    static generateUnexpectedError(error) {
        const errorMessage = `${errors_1.UNEXPECTED_ERROR_MESSAGE_INTRODUCTION}: \n${error.message}`;
        return ErrorHandling.generateErrorResult(errorMessage);
    }
    static hasError(param) {
        return !!param.errorMessage;
    }
}
exports.ErrorHandling = ErrorHandling;
